import { GeneralOverlay } from "../general/general-overlay";
import { ApplyWrappedStyles } from "@app/scripts/css-injectors/wrapped-shadow-style-injector";
import { ApplyGiftNoteStyles } from "@app/scripts/css-injectors/giftnote-shadow-style-injector";
export class PreviewCart extends HTMLElement {
  public cartRefreshUnsubscriber: any;

  public previewCartSection: HTMLElement | null;
  public previewCart: HTMLElement | null;
  public previewCartErrorWrapper: HTMLElement | null;
  public loadingOverlay: HTMLElement | null;
  public ctaButton: HTMLElement | null;
  public ctaButtonLoader: HTMLElement | null;
  public parentSectionId: string;
  public giftSectionToggleBtn: HTMLElement | null;
  public giftAccordionContent: HTMLElement | null;
  public giftAccordionHeader: HTMLElement | null;

  constructor() {
    super();

    this.previewCartSection = document.querySelector(".section-preview-cart");
    this.previewCart = document.querySelector(".section-preview-cart preview-cart");
    this.previewCartErrorWrapper = document.querySelector(".section-preview-cart .product-form__error-message-wrapper");
    this.loadingOverlay = document.querySelector(".section-preview-cart .preview-cart__loading");
    this.ctaButton = document.querySelector(".main-product .product__cart-cta");
    this.ctaButtonLoader = this.ctaButton?.querySelector(".loading__spinner");
    this.parentSectionId = this.previewCartSection.id?.replace('shopify-section-', '');
    this.giftSectionToggleBtn = this.querySelector(".preview-cart__gift-accordion-toggle-btn");
    this.giftAccordionContent = this.querySelector(".preview-cart__gift-accordion-content");
    this.giftAccordionHeader = this.querySelector(".preview-cart__gift-section-header");
    if (this.giftAccordionHeader) {
      this.giftAccordionHeader.addEventListener("click", () => this.toggleGiftAccordion(this.giftAccordionHeader));
    }
    this.applyWidgetStyles();

    // Register wrappedCallback listener only once
    if (!window._previewCartCallbackRegistered) {
      window._previewCartCallbackRegistered = true;
      document.addEventListener("wrappedCallback", () => {
          this.updateCartHTML();
      });
    }
  }

  openPreviewCart(refresh?: boolean) {
    this.applyWidgetStyles();
    this.previewCartSection?.classList.add("open");

    const generalOverlay = new GeneralOverlay();
    generalOverlay.applyOverlay(this.previewCartSection);

    if (refresh) {
      this.loadingOverlay?.classList.remove("hidden");
      this.updateCartHTML();
    }
  }

  closePreviewCart() {
    this.previewCartSection?.classList.remove("open");
    this.clearStatus();

    const generalOverlay = new GeneralOverlay();
    generalOverlay.removeOverlay(this.previewCartSection);
  }

  addItems(items: any) {
    const body = {
      items: items,
      sections: this.parentSectionId,
    };

    if (this.ctaButton && this.ctaButtonLoader) {
      this.ctaButton.classList.add("loading");
      this.ctaButtonLoader.classList.remove("hidden");
    }

    return this.fetchPreviewCart(this.getRequestUrl("add"), body);
  }

  addUpsellItem(itemKey: string, quantity: number, properties: object = {}) {
    this.loadingOverlay?.classList.remove("hidden");

    const body = {
      items: [
        {
          id: itemKey,
          quantity: quantity,
          properties: properties,
        },
      ],
      sections: this.parentSectionId,
    };

    this.fetchPreviewCart(this.getRequestUrl("add"), body).then((data: any) => {
      if (this.ctaButton && this.ctaButtonLoader) {
        this.ctaButton.classList.remove("loading");
        this.ctaButtonLoader.classList.add("hidden");
      }
      this.refreshPreviewCart(data);
      this.loadingOverlay?.classList.add("hidden");
  });
  }

  updateCartHTML() {
    function handleResponse() {
      try {
        const cartPreviewHtml = JSON.parse(request.responseText)[`${this.parentSectionId}`];
        // Declared outside the if block so the cart:updated dispatch below can read it -- SG 20261005
        let cartItemCount: string | undefined;
        if (cartPreviewHtml) {
          const sectionInnerHtml = this.getSectionInnerHTML(cartPreviewHtml, "preview-cart") as string;
          cartItemCount = this.getSectionInnerHTML(
            cartPreviewHtml,
            ".preview-cart__heading-count span"
          ) as string;

          if (this.previewCart) {
            this.previewCart.innerHTML = sectionInnerHtml;
          }

          const cartPage = document.querySelector(".section-cart preview-cart");
          if (cartPage) {
            cartPage.innerHTML = sectionInnerHtml;
          }

          const countIcon = document.querySelector(".header-content__right .icon-pram div") as any;
          if (countIcon) {
            countIcon.innerHTML = cartItemCount;
          }
        }

        this.openPreviewCart();
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: parseInt(cartItemCount || '0', 10) } }));

        if (this.ctaButton && this.ctaButtonLoader) {
          this.ctaButton.classList.remove("loading");
          this.ctaButtonLoader.classList.add("hidden");
        }

      } catch (error) {
        console.error("error at updateCartHTML: ", error);
      }
    }

    const request = new XMLHttpRequest();

    request.addEventListener("load", handleResponse.bind(this));
    request.open("GET", `/?sections=${this.parentSectionId}`, true);
    request.send();
  }

  addItem(itemKey: string, quantity: number, properties: object = {}) {
    // console.log("properties: ", properties);
    this.openPreviewCart();

    const body = {
      items: [
        {
          id: itemKey,
          quantity: quantity,
          properties: properties,
        },
      ],
      sections: this.parentSectionId,
    };

    return this.fetchPreviewCart(this.getRequestUrl("add"), body);
  }

  removeBundle(updates: object = {}) {
    this.loadingOverlay?.classList.remove("hidden");

    if(Object.keys(updates).length > 0) {
      this.fetchPreviewCart(this.getRequestUrl("update"), {updates}).then((data: any) => {
          if (this.ctaButton && this.ctaButtonLoader) {
            this.ctaButton.classList.remove("loading");
            this.ctaButtonLoader.classList.add("hidden");
          }
          this.updateCartHTML();
          this.loadingOverlay?.classList.add("hidden");
      });
    }     
  }

  removeItem(itemKey: string, bundleProducts: Array<string>) {
    this.loadingOverlay?.classList.remove("hidden");

    let productsArr:any = [];
     
    if (bundleProducts.length) {
      let updates = {[itemKey]: 0};

      bundleProducts.forEach((item: any) => {
        updates[item.id] = 0
        productsArr.push({
          id: item.id,
          quantity: item.quantity
        })
      })
      
      this.fetchPreviewCart(this.getRequestUrl("update"), {updates}).then((data: any) => {
        if (data.status && data.status >= 400) {
        } else {
    
          this.addItems(productsArr)
          .then((data: any) => {

            if (this.ctaButton && this.ctaButtonLoader) {
              this.ctaButton.classList.remove("loading");
              this.ctaButtonLoader.classList.add("hidden");
            }
            this.refreshPreviewCart(data);
          })
        }
      });
    }
    else {
      const body = {
        id: itemKey,
        quantity: 0,
        sections: this.parentSectionId,
      };
      this.fetchPreviewCart(this.getRequestUrl("change"), body).then((data: any) => {
        if (data.status && data.status >= 400) {
        } else {
          if (this.ctaButton && this.ctaButtonLoader) {
            this.ctaButton.classList.remove("loading");
            this.ctaButtonLoader.classList.add("hidden");
          }
          this.refreshPreviewCart(data);
        }
      });
    }
  }

  updateBundles(): Promise<void> { // Removes the hidden _bundle... attributes when the bundle has a missing product - Built for the custom pixel.
    return new Promise((resolve) => {
      this.fetchPreviewCart(this.getRequestUrl("get"), {}).then((res) => {
        const lineItems = res?.items;
        const parseBundleMatcher = (matcher: string) => {
          if(!matcher) return null;

          const parts = matcher.split('--');
          return {
            productCount: parseInt(parts[0], 10),
            timestamp: parts[1]
          };
        };

        try {
          const bundleGroups: Record<string, {productCount: number, items: any[]}> = {};
          
          lineItems.forEach((item) => {
            const matcher = parseBundleMatcher(item.properties?._bundleMatcher);
            if (matcher) {
              if (!bundleGroups[matcher.timestamp]) {
                bundleGroups[matcher.timestamp] = {
                  productCount: matcher.productCount,
                  items: []
                };
              }
              bundleGroups[matcher.timestamp].items.push(item);
            }
          });

          const validatedBundles = Object.entries(bundleGroups).map(([timestamp, group]) => {
              const hasCorrectCount = group.items.length === group.productCount; // Overkill?
              const isDiscountedBundle = group.items.every(item => {
                const isBundleItem = item.properties?.Bundle !== undefined;
                const isDiscounted = item.final_line_price !== item.original_line_price;
                return (isBundleItem && isDiscounted);
              });

              const isValid = hasCorrectCount && isDiscountedBundle;
              
              return {
                timestamp,
                ...group,
                isValid
              };
            });

          const invalidBundles = validatedBundles.filter(b => !b.isValid);

          if(invalidBundles.length) {
            const updates: Record<string, any> = {};

            invalidBundles.forEach(bundle => {
              bundle.items.forEach(item => {
                const cleanProperties = Object.fromEntries(
                  Object.entries(item.properties || {})
                    .filter(([key]) => !key.startsWith('_bundle'))
                );

                updates[item.key] = {
                  quantity: item.quantity,
                  properties: cleanProperties,
                  sections: this.parentSectionId,
                };
              });
            });

            this.fetchPreviewCart(this.getRequestUrl("update"), updates).then(() => {
              resolve();
            });
          } else {
            resolve();
          }

        } catch(e) {
          console.error(e)
        }

      })
    });
  }

  updateItem(itemKey: string, quantity: number, oldQuantity: number, variantId?: string) {
    this.loadingOverlay?.classList.remove("hidden");

    const body = {
      id: itemKey,
      quantity: quantity,
      sections: this.parentSectionId,
    };

    if (variantId) {
      let productsArr: any = [];
      productsArr.push({
        id: variantId,
        quantity: 1
      })
      this.addItems(productsArr)
          .then((data: any) => {

            if (this.ctaButton && this.ctaButtonLoader) {
              this.ctaButton.classList.remove("loading");
              this.ctaButtonLoader.classList.add("hidden");
            }
            this.refreshPreviewCart(data);
          })
    } else {
      this.fetchPreviewCart(this.getRequestUrl("change"), body).then((data: any) => {
        if (data.status && data.status >= 400) {
          const inputElement = this.querySelector("input") as HTMLInputElement;
          if (inputElement) {
            inputElement.value = oldQuantity + "";
          }
  
          this.cartErrorHandling(this.previewCartErrorWrapper, data.description);
        } else {
          this.updateBundles().then(() => {
            this.refreshPreviewCart(data);
          });
        }
      });
    }
  }

  fetchPreviewCart(url: string, body: any) {
    const promise = new Promise((resolve, reject) => {
      const strigifyBody = JSON.stringify(body);

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
        body: strigifyBody,
      })
        .then((response) => response.json())
        .then((data) => {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        });
    });

    return promise;
  }

  refreshPreviewCart(data: any) {
    this.clearStatus();
    const cartPreviewHtml = data.sections[`${this.parentSectionId}`];

    if (cartPreviewHtml) {
      const sectionInnerHtml = this.getSectionInnerHTML(cartPreviewHtml, "preview-cart") as string;
      const cartItemCount = this.getSectionInnerHTML(cartPreviewHtml, ".preview-cart__heading-count span") as string;

      if (this.previewCart) {
        this.previewCart.innerHTML = sectionInnerHtml;
      }

      const cartPage = document.querySelector(".section-cart preview-cart");
      if (cartPage) {
        cartPage.innerHTML = sectionInnerHtml;
      }

      const countIcon = document.querySelector(".header-content__right .icon-pram div") as any;
      if (countIcon) {
        countIcon.innerHTML = cartItemCount;
      }
      this.applyWidgetStyles();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { itemCount: parseInt(cartItemCount || '0', 10) } }));

      this.giftSectionToggleBtn = this.previewCartSection?.querySelector(".preview-cart__gift-accordion-toggle-btn");
      this.giftAccordionContent = this.previewCartSection?.querySelector(".preview-cart__gift-accordion-content");
      this.giftAccordionHeader = this.previewCartSection?.querySelector(".preview-cart__gift-section-header");
      this.giftAccordionHeader?.addEventListener("click", () => this.toggleGiftAccordion());
    }
  }

  applyWidgetStyles() {
    ApplyWrappedStyles();
    ApplyGiftNoteStyles();
  }

  cartErrorHandling(errorBannerElement: any, errorMessage: string) {
    const errorMessageElement = errorBannerElement.querySelector(".product-form__error-message") as HTMLElement;
    errorBannerElement?.classList.remove("hidden");
    errorMessageElement.innerHTML = errorMessage;
    this.loadingOverlay?.classList.add("hidden");
  }

  applyStatus() {}

  clearStatus() {
    const errorMessageElement = this.previewCartErrorWrapper?.querySelector(
      ".product-form__error-message"
    ) as HTMLElement;
    this.loadingOverlay?.classList.add("hidden");

    if (this.previewCartErrorWrapper) {
      this.previewCartErrorWrapper?.classList.add("hidden");
      errorMessageElement.innerHTML = "";
    }
  }

  getRequestUrl(type: string) {
    let url = "";
    switch (type) {
      case "get":
        url = "/cart.js";
        break;
      case "add":
        url = "/cart/add.js";
        break;
      case "update":
        url = "/cart/update.js";
        break;
      case "change":
        url = "/cart/change.js";
        break;
      default:
        url = "";
    }

    return url;
  }

  getSectionInnerHTML(html: string, selector: string) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector)?.outerHTML;
  }

  toggleGiftAccordion(header?: HTMLElement) {
    const content = header?.nextElementSibling as HTMLElement;
    const btn = header?.querySelector(".preview-cart__gift-accordion-toggle-btn") as HTMLElement;
    
    if (content && btn) {
      const isOpen = content.classList.contains("open");
      if (isOpen) {
        content.classList.remove("open");
        content.style.display = "none";
        btn.style.transform = "rotate(0deg)";
      } else {
        content.classList.add("open");
        content.style.display = "block";
        btn.style.transform = "rotate(180deg)";
      }
    }
  }
}

customElements.define("preview-cart", PreviewCart);